(function auditFindControllerDefinition() {
    'use strict';

    angular.module('Audit')
        .controller('AuditFindController', [
            '$scope', '$state', 'errorsExtend', 'authExtend', '$translate', 'auditService', 'fileDownloader', 'organizationalUnitService','storageService',
            function auditFindController($scope, $state, errors, auth, $translate, auditService, fileDownloader, organizationalUnitService, storageService) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                $scope.createFilters = function () {
                    
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;
                    var filters = {
                        actionType: $scope.find.actionType,
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        organizationalUnitId: idOu,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage,
                        userId: undefined,
                        nickName: $scope.find.name
                    };

                    $scope.find.showNoData = false;

                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return auditService.get(filters).then(function (result) {
                        $scope.auditItems = result.values;
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));

                        if ($scope.auditItems.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.auditItems.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.view = function (audit) {
                    $state.go('audit-detail', { id: audit.id });
                };

                $scope.findAction = function () {
                    if ($scope.searchAudit != null) {
                        if (!$scope.searchAudit.$valid) {
                            $scope.searchAudit.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return false;
                        }
                    }
                    
                    if ($scope.find.actionType && ($scope.find.actionType.id === -1 || $scope.find.actionType.id === null)) {
                        $scope.find.actionType = null;
                    }

                    if (!$scope.find.organizationalUnit || $scope.find.organizationalUnit.id === -1) {
                        $scope.find.organizationalUnit.id = null;
                    }   

                    $scope.find.firstTime = false;
                    storageService.setAuditFilter($scope.find);
                    storageService.setAuditPagination($scope.data);                    
                    return $scope.executeFind();
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;
                    storageService.clearAuditFilter();
                    $scope.find = storageService.getAuditFilter();
                    storageService.clearAuditPagination();
                    $scope.data = storageService.getAuditPagination();
                    $scope.find.organizationalUnit = $scope.organizationalUnits[0];
                    $scope.auditItems = [];
                    $scope.find.actionType = $scope.actionTypes[0];
                };

                $scope.fillAccordion = function () {
                    $scope.auditItems.forEach(function (audit) {
                        var accordionIsOpen = false;
                        Object.defineProperty(audit, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {

                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {

                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.export = function () {

                    var filters = $scope.createFilters();
                    auditService.export(filters).then(function getOk(result) {
                        var resultado = result.values;
                        var d = new Date();
                        var month = d.getUTCMonth() + 1;
                        var success = fileDownloader.saveAs(result.value, 'Listado de Auditorias ' +
                            d.getUTCFullYear() +
                            ("00".substring(0, 2 - (month + '').length) + month) +
                            ("00".substring(0, 2 - (d.getDate() + '').length) + d.getDate()) +
                            '.xlsx');
                        if (!success) {
                            errors.showError('Api failed');
                        }
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.data = storageService.getAuditPagination();
                    $scope.find = storageService.getAuditFilter();
                    $scope.emptyOu = true;

                    $scope.userId = auth.getUserId();

                    auditService.getTypes().then(function (result) {
                        $scope.actionTypes = result;
                        $scope.actionTypes.unshift({
                            id: -1,
                            traslatedName: '[Todas]'
                        });
                        if ($scope.find.actionType == null) {
                            $scope.find.actionType = $scope.actionTypes[0];
                        }
                    }, function (error) {
                        errors.showError(error);
                    });

                    organizationalUnitService.getOuTReeControl().then(function (result) {
                        $scope.organizationalUnits = result;
                        $scope.organizationalUnits.unshift({
                            id: -1,
                            entityDescription: '[Todas]'
                        });
                        if ($scope.find.organizationalUnit.id == null) {
                            $scope.find.organizationalUnit = $scope.organizationalUnits[0];
                        }
                        
                    }, function (error) {
                        errors.showError(error);
                        });
                    if ($scope.find.firstTime == false) {
                        $scope.findAction();
                    }

                };
                    $scope.load();
                }]);
})();